import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface RotuloDeFiltroProps {
  children: ReactNode;
  /** Para enlazarlo con un control que no puede llevar `htmlFor`, como un
      `combobox`, que no toma su nombre del contenido. */
  id?: string;
  htmlFor?: string;
  className?: string;
}

/**
 * El rótulo de un control de filtro.
 *
 * Es MÁS CHICO Y EN VERSALITAS que un `Label` de formulario, y no es una
 * preferencia: en un formulario el rótulo nombra el dato que se está cargando y
 * pesa tanto como él; en una barra de filtros hay seis controles seguidos y lo
 * que el ojo busca es el VALOR puesto, no el nombre de la casilla. En
 * mayúsculas chicas el rótulo se lee de un vistazo sin competir con la cifra.
 *
 * Existe como componente porque la misma cadena de clases estaba escrita en
 * tres lugares —los dos pasos de referencias y la franja del predio— y el
 * cuarto se iba a escribir distinto.
 */
export function RotuloDeFiltro({ children, id, htmlFor, className }: RotuloDeFiltroProps) {
  return (
    <label
      id={id}
      htmlFor={htmlFor}
      className={cn(
        "text-ink-muted text-[0.625rem] font-extrabold tracking-[0.05em] uppercase",
        className,
      )}
    >
      {children}
    </label>
  );
}
